import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import App from "./app";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
